import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { DownloadType } from '../../component/download-form/dto/enum/download-type.enum';
import { DownloadFormComponent } from '../../component/download-form/download-form.component';
import { DownloadState } from '../../component/download-form/dto/enum/download-state.enum';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { GreetingsComponent } from '../../component/greetings/greetings.component';
import { BenefitsComponent } from '../../component/benefits/benefits.component';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';
import { benefitsDTO } from './photo-downloader-page.benefits';
import { IGreetingsDTO } from '../../dto/greetings/greetings.dto';
import { greetingsDTO } from './photo-downloader-page.greetings';
import { InstructionComponent } from '../../component/instruction/instruction.component';
import { instructionDTO } from './photo-downloader-page.instruction';
import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import { MetaService } from '../../service/meta.service';
import { YaBannerService } from '../../service/ya-banner.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-photo-downloader-page',
  imports: [
    NzColDirective,
    NzRowDirective,
    NzTypographyComponent,
    DownloadFormComponent,
    NzAlertComponent,
    GreetingsComponent,
    BenefitsComponent,
    InstructionComponent,
  ],
  templateUrl: './photo-downloader-page.component.html',
  styleUrl: './photo-downloader-page.component.less',
})
export class PhotoDownloaderPageComponent implements OnInit {
  private static readonly URI: 'photo-downloader' = 'photo-downloader' as const;
  public readonly DownloadType: typeof DownloadType = DownloadType;
  public readonly DownloadState: typeof DownloadState = DownloadState;
  public readonly processableStates: DownloadState[] = [
    DownloadState.CAPTCHA_ERROR,
    DownloadState.NOT_FOUND_ERROR,
    DownloadState.UNEXPECTED_ERROR,
    DownloadState.OK,
  ];
  public readonly benefitsDTO: IBenefitsDTO = benefitsDTO;
  public readonly greetingsDTO: IGreetingsDTO = greetingsDTO;
  public readonly instructionDTO: IInstructionDTO = instructionDTO;
  public downloadState: DownloadState = DownloadState.INIT;
  private readonly metaService: MetaService = inject(MetaService);
  private readonly yaBannerService: YaBannerService = inject(YaBannerService);

  public ngOnInit(): void {
    this.metaService.setTitle(
      $localize`:@@page-photo-downloader-title:Instagram photo downloader. Save your favorite photos: Ig4u`
    );
    this.metaService.setDescription(
      $localize`:@@page-photo-downloader-description:Download Instagram photos easily with Ig4u! Our Instagram photo downloader makes it simple: share the post link with us and in just a few clicks, you can relish your favorite images hassle-free. Fast and simple!`
    );
    this.metaService.setKeywords(
      $localize`:@@page-photo-downloader-keywords:download instagram photos, instagram photo downloader, download photos from instagram, ig4u`
    );
    this.metaService.setCanonical(PhotoDownloaderPageComponent.URI);
    this.metaService.setAlternatives(PhotoDownloaderPageComponent.URI);
    this.metaService.enableIndexing();
    this.yaBannerService.push(
      'R-A-15626278-3',
      'yandex_rtb_R-A-15626278-3',
      'banner'
    );
  }

  public onDownloadStateChanged(downloadState: DownloadState): void {
    this.downloadState = downloadState;
  }
}
